import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, RouterState, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/route-guards/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private authService: AuthService, private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.data.allowedRoles.includes(this.authService.role))
      return true;

    this.router.navigate(['/access-denied']);
    return false;
  }
}
